import { ProjectActivityMaterialsDataGridBase } from "src/components/views/erp/project/projectActivity/material/ProjectActivityMaterialsDataGridBase.tsx";
import { ProjectActivityMaterialsDataGridApi } from "src/api/generated/erp/project/projectActivityMaterial/api/projectActivityMaterialsDataGridApi.ts";

export interface ProjectAllActivityMaterialsDataGridProps {
	projectId: number;
}

export const ProjectAllActivityMaterialsDataGrid = ({ projectId }: ProjectAllActivityMaterialsDataGridProps) => {
	return (
		<ProjectActivityMaterialsDataGridBase
			gridId={"D362AAECDED2C493"}
			fetchData={({
				showCancelledLines,
				subProjectId,
				searchQuery,
				stateFilter,
				acquisitionMethodFilter,
				lineFilterMode,
				dataModelRequest,
			}) =>
				ProjectActivityMaterialsDataGridApi.getDataGridDataForProject({
					projectId: projectId,
					subProjectId: subProjectId,
					cancelledLines: showCancelledLines,
					searchQuery: searchQuery,
					stateFilter: stateFilter,
					acquisitionMethodFilter: acquisitionMethodFilter,
					lineFilterMode: lineFilterMode,
					dataModelRequest: dataModelRequest,
				})
			}
			showSubProjectColumn
			showActivityColumn
			showSubProjectFilter
		/>
	);
};
